export class CalculateVedocRequest {
  doRequest: boolean;

  constructor(doRequest: boolean) {
    this.doRequest = doRequest;
  }
}
